import styled from 'styled-components'

const Header = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 200px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-color: black;
  background-image: url('https://assets.riparide.com/login_page/auth-14082022.jpg');
  @media (min-width: 768px) {
    height: 300px;
  }
`

export default Header
